import React from 'react';
import { Alert, Button, Space } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './PhdArchivedRecordNotice.scss';

const reasonMeta = {
  school_year_closed: {
    label: 'Uzavretý školský rok',
    help: 'Ročné dáta boli pri prechode školského roka zmrazené.',
  },
  student_finished: {
    label: 'Ukončené štúdium',
    help: 'Po riadnom ukončení štúdia nemožno záznamy o jeho priebehu priamo meniť.',
  },
  student_expelled: {
    label: 'Vylúčenie zo štúdia',
    help: 'Po vylúčení zo štúdia nemožno záznamy o jeho priebehu priamo meniť.',
  },
};

const PhdArchivedRecordNotice = ({ record }) => {
  const { t } = useTranslation();

  if (record?.archive_status !== 'archived' && !record?.archived_at) {
    return null;
  }

  const reasons = (record.archive_reason_keys || [])
    .map((reason) => reasonMeta[reason])
    .filter(Boolean);

  return (
    <Alert
      type="info"
      showIcon
      title={t('Archivovaný záznam')}
      description={
        <Space orientation="vertical" size={8}>
          <span>
            {t(
              'Záznam je iba na čítanie. Môžete ho prezerať, vytlačiť alebo exportovať dostupný dokument.',
            )}
            {reasons.length
              ? ` ${t('Dôvod')}: ${reasons.map((reason) => t(reason.label)).join(', ')}. ${reasons.map((reason) => t(reason.help)).join(' ')}`
              : ''}{' '}
            {t(
              'Ak je historický údaj chybný, použite povolený korekčný postup alebo kontaktujte administrátora doktorandského štúdia; pôvodný záznam neprepisujte.',
            )}
          </span>
          <Button
            icon={<PrinterOutlined />}
            onClick={() => window.print()}
            className="phd-archive-print-button"
          >
            {t('Vytlačiť')}
          </Button>
        </Space>
      }
      style={{ marginBottom: 16 }}
    />
  );
};

export default PhdArchivedRecordNotice;
